import assign from 'lodash/assign';
import uiRouter from '@uirouter/angularjs';

import template from './embedVideoModal.html';

export const RedactorEmbedVideoModalModule = angular
    .module('app.components.redactor.redactorEmbedVideoModal', [
        'ngMaterial',
        uiRouter
    ]).component('redactorEmbedVideoModal', {
        template,
        controller: class EmbedVideoModalController {
            constructor(
                $scope,
                $mdDialog,
                $state
            ) {
                'ngInject';

                assign(this, {
                    video: {},
                    regex: /(youtube\.com|youtu\.be)/g,
                    $scope,
                    $mdDialog,
                    $state
                });
            }

            $onInit() {
                this.stateName = this.$state.current.name;
            }

            confirm() {
                this.$mdDialog.hide(this.video);
            }

            cancel() {
                this.$mdDialog.cancel('cancel');
            }
        }
    }).name;



// WEBPACK FOOTER //
// ./src/app/components/redactor/components/embedVideoModal.component.js